import { cn } from "@/lib/utils";
import React from "react";

interface CardProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  "data-testid"?: string;
}

const Card = ({
  className,
  children,
  onClick,
  "data-testid": dataTestId,
}: CardProps) => {
  return (
    <div
      role={onClick && "button"}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      className={cn(
        "flex w-full flex-row items-center justify-between gap-[10px] rounded-lg bg-[#1FB3CC1F] px-[10px] py-3 shadow-[0px_1px_2px_0px_rgba(12,12,38,0.20)] backdrop-blur-lg",
        className
      )}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default Card;
